import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-checkpoint-panel',
  templateUrl: './checkpoint-panel.component.html',
  styleUrl: './checkpoint-panel.component.scss',
  standalone: false
})
export class CheckpointPanelComponent {
  /** Badge modifier class next to the label — 'in-progress' for checkpoints, 'finished' at the finish. */
  @Input() badgeClass = 'in-progress';
  @Input() badgeLabel = '';

  /** Pre-formatted values — desktop shows all of these inline in the header row. */
  @Input() dateText = '';
  @Input() passTimeText = '';
  @Input() totalTimeText = '';
  @Input() totalTimeAfterPenalty = false;
  @Input() rankText: string | undefined;
  @Input() showTeamMembers = false;
  @Input() rows: any[] = [];
  @Input() isFinish = false;
  @Input() race: any | undefined;
  @Input() penalty: number | undefined;

  /** Solo-competitor rank breakdown. */
  @Input() overallRank: string | number | undefined;
  @Input() sexRank: string | number | undefined;
  @Input() categoryRank: string | number | undefined;
  @Input() competitorSex: number | undefined;
  @Input() categoryLabel: string | undefined;
  @Input() expandable: boolean = false;

  expanded = false;

  onExpand() {
    if (this.expandable) {
      this.expanded = !this.expanded;
    }
  }
}